import React from 'react'
import "./Contactus.css"


//assets 
import contact_image from "../../assets/contact_img.png"
import address from "../../assets/location.png"
import phone from "../../assets/phone-call.png"
import telephone from "../../assets/handset.png"
import mail from "../../assets/mail1.png"

const Contactus = () => {
  return (
    <>
    <div className='contact_img'>
      <img src={contact_image} alt="" />
      <div className='textover_img'>
          <p> Contact us</p>
      </div>
    </div>
    <div className='address_container'>
      <div className='address'>

         <h1>Contact information</h1>
         <p> <img src={address} alt="" /> 93-99, Nehru street,opposite to senthil kumaran theatre,<br/>
          Ram nagar, Coimbatore ,Tamilnadu-641 009
        </p>
        <p>
           <img src={phone} alt="" />+91- 6369  403  803, +91- 9944  333  055
        </p>
        <p>
           <img src={telephone} alt="" /> 0422 3161394
        </p>
        <p>
           <img src={mail} alt="" />swtcbe@gmail.com
        </p>
       
    </div>
       
           <div className='map'>
           <h1>Click to view location</h1>
           <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d7832.652251548687!2d76.9623685!3d11.0141397!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDAwJzU0LjUiTiA3NsKwNTcnNTIuNCJF!5e0!3m2!1sen!2sin!4v1738066375027!5m2!1sen!2sin"
             allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className='mapstyle'></iframe>
        </div>
  </div>
    </>
  )
}

export default Contactus